var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":!_vm.label,"small":_vm.small,"color":_vm.copyIconColors[_vm.iconStatus]},on:{"click":_vm.copyToken}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("\n    "+_vm._s(_vm.copyIcons[_vm.iconStatus])+"\n  ")]),_vm._v(" "),(_vm.label)?_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }